import React from 'react';
import PropTypes from 'prop-types'
import _map from 'lodash/map';
import PresetAmountButton from './PresetAmountButton';
import {
	getNormalizedNumber
} from './amountUtils';

class PresetAmountButtons extends React.Component {
	handleClick(event, value) {
		this.props.handlePresetAmountClick(event, value);
	}

	render() {
		return (
			<div>
				<div className="vx_btn-group amount-btn-group hide-xs-screens">
					{
						_map(this.props.amounts, (amount, index) => {
							const normalizedAmount = '' + getNormalizedNumber(this.props.selectedAmount);
							const isSelected = amount === normalizedAmount;
							return (
								<PresetAmountButton
									key={index}
									value={amount}
									selected={isSelected}
									symbol={this.props.symbol}
									charityAmountCode={this.props.charityAmountCode}
									handleAmountBtnClick={this.handleClick.bind(this)}
								/>
							)
						})
					}
				</div>
				<div className="row visible-xs-screens">
					{
						_map(this.props.amounts, (amount, index) => {
							const normalizedAmount = '' + getNormalizedNumber(this.props.selectedAmount);
							const isSelected = amount === normalizedAmount;
							
							return (
								<div key={index} className="col-xs-12">
									<PresetAmountButton
										key={index}
										value={amount}
										selected={isSelected}
										symbol={this.props.symbol}
										charityAmountCode={this.props.charityAmountCode}
										handleAmountBtnClick={this.handleClick.bind(this)}
									/>
								</div>
							)
						})
					}

				</div>
			</div>
		)


	}
}

PresetAmountButtons.propTypes = {
	amounts: PropTypes.array,
	handlePresetAmountClick: PropTypes.func,
	selectedAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	symbol: PropTypes.string,
	charityAmountCode: PropTypes.string
};

export default PresetAmountButtons;



// WEBPACK FOOTER //
// ./components/amount/PresetAmountButtons.js